import { Box, Button, Grid, Skeleton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { NumberInput, required, useGetOne, useNotify, useRedirect, useTranslate } from 'react-admin'
import { paymentServices } from 'src/services/payment/Payment.service'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import DeleteIcon from '@mui/icons-material/Delete';
import { FormDivider } from 'src/components/uiElements/fields/Divider'
import { Add } from '@mui/icons-material'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_EDIT } from 'src/helper/Permission'
import EditIcon from '@mui/icons-material/Edit'
import { userServices } from 'src/services/reservation/user/user.service'
import { CurrencyExchangeModal } from './CurrencyExchangeModal'
import { reverseExchangeRate } from 'src/components/pages/payment/payment/logic/common/calculateReverseExchangeRate'
import { itemSupplierServices } from 'src/services/purchases/item_supplier/ItemSupplier.service'
import { basesServices } from 'src/services/reservation/bases/Bases.service'
import { useLocation, useSearchParams } from "react-router-dom";
import { ModalPayment } from 'src/components/pages/payment/payment/logic/ModalPayment'
import { SupplierPaymentOrderShow } from '../SupplierPaymentOrderShow'
import { LoadingButton } from '@mui/lab'
import { CardCommon } from "src/components/uiElements"
import PaymentsIcon from '@mui/icons-material/Payments';

export const SupplierPaymentOrderPay = () => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const { data: record } = useGetOne(
    'supplier-payment-order',
    { id },
    { enabled: !!id }
  )
  const redirect = useRedirect()
  const translate = useTranslate()
  const { search } = useLocation();
  const paymentOrderId = Number(new URLSearchParams(search).get("id"));
  const notify = useNotify()
  const [loadingCurrencyList, setLoadingCurrencyList] = useState()
  const [currencyList, setCurrencyList] = useState([])
  const [loadingCashList, setLoadingCashList] = useState()
  const [cashList, setCashList] = useState([])
  const [loadingBankList, setLoadingBankList] = useState()
  const [bankList, setBankList] = useState([])
  const [amountToPay, setAmountToPay] = useState(0)
  const [totalItemsAmount, setTotalItemsAmount] = useState(0)
  const [currentIndexSelected, setCurrentIndexSelected] = useState(null)
  const [selectedRecord, setSelectedRecord] = useState({})
  const [openExchangeModal, setOpenExchangeModal] = useState(false)
  const [paymentExchanges, setPaymentExchanges] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [isPaying, setIsPaying] = useState(false)
  const [loadingPaymentTpes, setLoadingPaymentTypes] = useState(false)
  const [paymentTypes, setPaymentTypes] = useState([{ id: '', long_name: 'No seleccionado', disabled: true }])
  const [basesList, setBasesList] = useState([])
  const [loadingBases, setLoadingBases] = useState(false)
  const [totalAmount, setTotalAmount] = useState(0)
  const [reftableTypes, setRefTableTypes] = useState([])
  const [paymentMethodsData, setPaymentMethodsData] = useState([])
  const form = useForm({
    defaultValues: {
      currencies_exchange:[],
      hash_currency: null,
      paymentType: [{ payment_type: null }]
    }
  })
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'paymentType'
  })

  useEffect(()=>{
    getPaymentTypes()
    getBases()
    getExchangeByUserById()
    getCurrencies()
    getCashOptions()
    getBankOptions()
    getPaymentMethods()
  },[])

  useEffect(() => {
    let amount = 0
    if(record){
      for(let item of (record?.supplier_payment_order_item_relation ?? [])){
        amount = amount + item.amount
      }
      setTotalItemsAmount(amount)
    }
  }, [record])

  useEffect(() => {
    if(record && form.getValues('hash_currency')){
      if(form.getValues('hash_currency') === record.currency_relation?.hash_currency){
        setAmountToPay(totalItemsAmount)
      } else {
        const selectedExchange = paymentExchanges.find(
          exchange=>
            exchange.currency_to_relation?.hash_currency === form.getValues('hash_currency') &&
            exchange.currency_relation?.hash_currency === record.currency_relation?.hash_currency
        )
        if(selectedExchange){
          setAmountToPay(Math.round((totalItemsAmount * selectedExchange.value)*100)/100)
        } else { // si no encuentra el tipo de cambio para hacer la cuenta, es un error de configuracion
          notify('ra.notification.currency_exchange_not_found',{type:'error'})
          setAmountToPay(0)
        }
      }
    }
  }, [form.watch('hash_currency'), JSON.stringify(paymentExchanges), totalItemsAmount])

  const cashOrBank = (refDetail) =>{
    if(refDetail === 'payment_bank'){
      return 'bank'
    }
    if(refDetail === 'payment_cash'){
      return 'cash'
    }
    return null
  }

  const onClickOpenMenu = (payment_type_id, index) => {
    const payment = paymentTypes.find((elem) => elem.id === payment_type_id)
    if(payment?.ref_table_detail !== "payment_bank"){
      form.setValue(`paymentType[${index}].bank_name`, null)
    }
    setRefTableTypes(types=>{
      let newTypes = [...types]
      if(types[index]){
        newTypes[index] = payment?.ref_table_detail
      } else {
        newTypes.push(payment?.ref_table_detail)
      }
      return newTypes
    })
    let record = {
      config: payment?.config,
      name: payment?.long_name,
      source: `paymentType.${index}`,
    }
    setCurrentIndexSelected(index)
    setSelectedRecord((current) => ({
      ...current,
      [index]: record,
    }))
    if(payment?.ref_table_detail === 'payment_online'){
      setOpenModal(true)
    }
  }

  const getCurrencies = async () => {
    try {
      setLoadingCurrencyList(true)
      const allCurrencies = await userServices.getCurrenciesToByUser()
      setCurrencyList(allCurrencies)
      setLoadingCurrencyList(false)
    } catch (error) {
      setCurrencyList([])
      setLoadingCurrencyList(false)
    }
  }

  const getCashOptions = async () => {
    try {
      setLoadingCashList(true)
      const allCachOptions = await userServices.getCashOptionsByUser()
      setCashList(allCachOptions)
      setLoadingCashList(false)
    } catch (error) {
      setCashList([])
      setLoadingCashList(false)
    }
  }

  const getBankOptions = async () => {
    try {
      setLoadingBankList(true)
      const allCachOptions = await userServices.getBankOptionsByUser()
      setBankList(allCachOptions)
      setLoadingBankList(false)
    } catch (error) {
      setBankList([])
      setLoadingBankList(false)
    }
  }

  const getPaymentMethods = async () => {
    try {
      const response = await paymentServices.getData('payment-method-by-work-unit/parents/undefined')
      setPaymentMethodsData(response)
    } catch (error) {
      setPaymentMethodsData([])
    }
  }

  const amountValidation = () =>{
    if(amountToPay){
      if(totalAmount < Math.floor(amountToPay) ){
        notify('ra.message.amount_to_pay_error_min',{type:'error'})
        return false
      }
      if(totalAmount > Math.ceil(amountToPay) ){
        notify('ra.message.amount_to_pay_error',{type:'error'})
        return false
      }
    } else {
      notify('ra.message.amount_to_pay_error',{type:'error'})
      return false
    }
    return true

  }

  const onSubmit = async () =>{
    if(!amountValidation()){
      return
    }
    const paymentType = form.getValues('paymentType').map(payment=>{
      const paymentDetails = Object.fromEntries(
        Object.entries(payment).filter(([key])=>!['currency', 'amount_to_pay', 'date'].includes(key))
      )
      if(paymentDetails.bank_name){
        const bank = bankList.find(b => b.name === paymentDetails.bank_name)
        if(bank?.code) paymentDetails.code = bank.code
      } else
      if(paymentDetails.cash_name){
        const cash = cashList.find(c => c.name === paymentDetails.cash_name)
        if(cash?.code) paymentDetails.code = cash.code
      } else
      if(paymentDetails.financial_entity){
        const paymentMethod = paymentMethodsData.find(pm => pm.id === paymentDetails.financial_entity)
        if(paymentMethod?.cards?.[0]?.code) paymentDetails.code = paymentMethod.cards[0].code
      }
      return {
        ...payment,
        currency:form.getValues('hash_currency'),
        details: paymentDetails
      }})
    setIsPaying(true)
    await itemSupplierServices.createPayment({
      paymentType,
      currencies_exchange:form.getValues('currencies_exchange'),
      base_id: form.getValues('base_id'),
      supplier_payment_order_id:paymentOrderId

    }).then(()=>{
      notify('ra.message.item_payment_generate_success',{type:'success'})
      redirect('/supplier-payment-order')
    }).catch(err=>{
      notify('ra.message.item_payment_generate_error',{type:'error'})
      if(err?.response?.status === 500 || err?.response?.status === 400){
        redirect('/supplier-payment-order')
      }
    }).finally(()=>{
      setIsPaying(false)
    })
  }

  const getExchangeByUserById = async () => {
    try {
      const exchanges = await userServices.getCurrencyByUser()
      if (exchanges) {
        setPaymentExchanges(exchanges)
        form.setValue(
          "currencies_exchange",
          exchanges.filter(c => !c.is_reverse)
        );
      }
    } catch (error) {
      setPaymentExchanges([])
    } finally {
    }
  }

  // sincroniza los tipos de cambio editados en el modal (form) con el estado usado para el resumen
  // y el calculo del saldo a pagar, regenerando los inversos a partir de los editados
  const onSaveExchangeModal = () => {
    const editedExchanges = (form.getValues('currencies_exchange') ?? []).map(exchange => ({
      ...exchange,
      value: Number(exchange.value)
    }))
    if (editedExchanges.some(exchange => !(exchange.value > 0))) {
      notify('ra.validation.minValue', { type: 'error', messageArgs: { min: 0 } })
      return
    }
    form.setValue('currencies_exchange', editedExchanges)
    setPaymentExchanges(reverseExchangeRate(editedExchanges))
    setOpenExchangeModal(false)
  }

  const getPaymentTypes = async () => {
    try {
      setLoadingPaymentTypes(true)
      const response = await paymentServices.getAllPaymentTypes()
      const UATP_LONG_NAME = "UATP"
      const paymentTypesAux = response.filter((elem) => (elem?.long_name !== UATP_LONG_NAME)).map((elem) => {
        return { ...elem, id_payment: elem.id }
      })
      setPaymentTypes([{ id: '', long_name: 'No seleccionado', disabled: true }, ...paymentTypesAux])
    } catch (error) {
      setPaymentTypes([])
    } finally {
      setLoadingPaymentTypes(false)
    }
  }

  const getBases = async () => {
    try {
      setLoadingBases(true)
      const response = await basesServices.getByAll()
      setBasesList([{ id: '', name: 'No seleccionado', disabled: true }, ...response])
    } catch (error) {
      setBasesList([])
    } finally {
      setLoadingBases(false)
    }
  }

  if (!id) return null

  return (
    <>
      <SupplierPaymentOrderShow {...record} hasEdit={false}/>

      <CardCommon title={translate('ra.field.payment_detail')}>
        <FormProvider {...form}>
          <form>
            <Grid container spacing={3} alignItems={'center'}  >

              <EditInputsWrap label={`${translate('ra.field.currency')}`} required md={6} lg={3} >
                {loadingCurrencyList ? (
                  <Skeleton variant='rectangular' height={40} />
                ) : (
                  <SelectInput
                    title={translate('ra.field.currency')}
                    source={'hash_currency'}
                    options={currencyList}
                    style={{width:'75%'}}
                    showSearch
                    optionValue='hash_currency'
                    optionsText={['short_name']}
                  />
                )}
              </EditInputsWrap>

              <EditInputsWrap label={translate('ra.entity.bases')} required md={6} lg={3}>
                {loadingBases ? (
                  <Skeleton variant='rectangular' height={40} />
                ) : (
                  <SelectInput
                    title={translate('ra.entity.bases')}
                    source={`base_id`}
                    options={basesList}
                    style={{width:'75%'}}
                    showSearch
                    optionsText={['name']}
                    optionValue='id'
                  />
                )}
              </EditInputsWrap>

              <EditInputsWrap label={translate('ra.title.balance_to_pay')} md={6} lg={2}>
                {loadingBases ? (
                  <Skeleton variant='rectangular' height={40} />
                ) : (
                  <TextField
                    disabled
                    title={translate('ra.title.balance_to_pay')}
                    value={amountToPay.toString().replace('.',',')}
                    size='small'
                  />
                )
                }
              </EditInputsWrap>

              <Grid item md={6} lg={4} title={translate('ra.title.update_exchange_type')}>
                <Box display={'flex'}  width={'100%'} paddingX={'60px'}>
                  {paymentExchanges.length > 0 && (
                    <Box display={'flex'}>
                      <Box className='currency_resume'>
                        {paymentExchanges
                          .filter((currency) => !currency?.is_reverse)
                          .map((currency, key) => (
                            <Box key={key}>
                              <Typography component='span' fontWeight='bold'>
                                {currency?.currency_relation?.short_name}-
                                {currency?.currency_to_relation?.short_name}: {currency.value}
                              </Typography>
                            </Box>
                          ))}
                      </Box>
                      {hasPermissionFunction('currency-by-work-unit', PERMISSION_EDIT) && (
                        <Box display={'flex'}>
                          <Button onClick={() => setOpenExchangeModal(true)}>
                            <EditIcon />
                          </Button>
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </Grid>

            </Grid>

            <Box className='divider_and_button_container_divider'>
              <FormDivider flex={7} show={true} text={translate('ra.field.payment_types')} />
            </Box>

            <div style={{display:'flex', flexDirection:'column'}}>
              {fields.map((field,index) => (
                <Grid container key={field.id}>
                  <EditInputsWrap label={
                    <span style={{ display: 'flex', alignItems: 'end', gap: 6 }}>
                      {`${translate('ra.field.payment_type')}`}
                      {reftableTypes[index] === 'payment_online' && <PaymentsIcon
                        fontSize="small"
                        color='error'
                        style={{cursor:'pointer'}}
                        onClick={() => setOpenModal(true)}
                      />}
                    </span>
                  } lg={2} md={2}>
                    {loadingPaymentTpes ? (
                      <Skeleton variant='rectangular' height={40} />
                    ) : (
                      <SelectInput
                        source={`paymentType[${index}].payment_type`}
                        options={paymentTypes}
                        fullWidth
                        showSearch
                        /* queryFn={() => supplierServices.getByParam({ limit: 999 })} */
                        optionsText={['long_name']}
                        onChange={(e) => onClickOpenMenu(e.target.value, index)}
                      />
                    )}
                  </EditInputsWrap>

                  <EditInputsWrap label={
                    cashOrBank(reftableTypes[index]) === 'bank' ?
                    `${translate('ra.field.bank')}`:
                    `${translate('ra.entity.cash')}`
                  } lg={2} md={2}>
                    {(loadingCashList || loadingBankList) ? (
                      <Skeleton variant='rectangular' height={40} />
                    ) : (
                      <SelectInput
                        source={`paymentType[${index}].${cashOrBank(reftableTypes[index]) === 'bank'?'bank_name':'cash_name'}`}
                        options={cashOrBank(reftableTypes[index]) === 'bank' ? bankList : cashList}
                        fullWidth
                        showSearch
                        disabled = {!cashOrBank(reftableTypes[index])}
                        optionValue='name'
                        optionsText={['name']}
                      />
                    )}
                  </EditInputsWrap>

                  <EditInputsWrap label={`${translate('ra.field.date')}*`} lg={2} md={2}>
                    <DatePickers
                      source={`paymentType[${index}].date`}
                      validate={[required()]}
                      viewsShow={false}
                      fullWidth
                      displayBlock
                    />
                  </EditInputsWrap>

                  <EditInputsWrap label={`${translate('ra.field.amount')}*`} lg={2} md={2}>
                    <NumberInput
                      label={null}
                      fullWidth
                      onChange={e=>{
                        setTotalAmount(prevValue=>
                          Math.round((prevValue+Number(e.target.value)
                          -Number(form.getValues("paymentType")[index]?.amount_to_pay))*100)/100
                        )
                      }}
                      source={`paymentType[${index}].amount_to_pay`}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          display: "none",
                        },
                      }}
                    />
                  </EditInputsWrap>

                  <EditInputsWrap  lg={3} md={3}>
                    <DeleteIcon color='error' style={{cursor:'pointer'}}
                      onClick={()=>{
                        setTotalAmount(prevValue=>prevValue - form.getValues("paymentType")[index]?.amount_to_pay)
                        setRefTableTypes(types=>{
                          let auxTypes = [...types]
                          auxTypes.splice(index, 1);
                          return auxTypes
                        })
                        remove(index)
                      }}
                    />
                  </EditInputsWrap>

                  <ModalPayment
                    key={field.id}
                    record={selectedRecord}
                    open={openModal}
                    index={currentIndexSelected}
                    handleClose={() => setOpenModal(false)}
                    selectedWorkUnit={null}
                    selectedBusinessUnit={null}
                    isPaymentOrder
                  />
                </Grid>
              ))}

              <TextField
                disabled
                value={totalAmount.toString().replace('.',',')}
                size='small'
                label={'Total'}
                style={{alignSelf:'flex-end', marginRight:'20%'}}
              />
            </div>

            <div style={{display:'flex', flexDirection:'column'}}>
              <Button
                startIcon={<Add />}
                style={{width:'20%'}}
                onClick={() => {
                  append({ payment_type: null, date: null, amount_to_pay: null })
                }}
              >
                {translate('ra.action.add_specific', {
                  name: translate('ra.field.payment_methods'),
                })}
              </Button>

              <LoadingButton loading={isPaying} style={{width:'15%', alignSelf:'flex-end'}} onClick={onSubmit} variant='contained'>
                {translate('ra.action.pay')}
              </LoadingButton>
            </div>

            <CurrencyExchangeModal
              open={openExchangeModal}
              handleClose={onSaveExchangeModal}
              titleModal={translate('ra.title.update_exchange_type')}
              paymentExchanges={paymentExchanges}
            />
          </form>
        </FormProvider>
      </CardCommon>
    </>
  )
}
